
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 5h24v6h-1v16H5V11H4V5zm2 2v2h20V7H6zm1 4v14h18V11H7zm5.813 2l.047-.001.047.001.047-.001.047.001h6.014a1 1 0 010 2h-6.014a1.005 1.005 0 01-1.098-1c0-.505.408-.953.911-1z"}})])
          )
        }
      }
    